export default "__VITE_ASSET__DZxJ6Zdh__"